import type { UserData } from '@/types/User'
import type { Squad } from '@/utils/squad'
import { toSquads } from '@/utils/squad'

export function aquireTokenSilently(instance: any, account: any) {
  return instance.acquireTokenSilent({
    account: account,
    scopes: [`${import.meta.env.VITE_B2C_APP_ID}`],
    forceRefresh: false,
  })
}

export async function resolveFullCustomer({
  token = '',
  customerId = '',
  accessKey,
}: {
  token: string
  customerId: any
  accessKey: string
}) {
  return fetch(`${import.meta.env.VITE_VOUCH_API}/dashboard/customers/${customerId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Ocp-Apim-Subscription-Key': accessKey,
    },
  })
}

export type SignInUser = UserData & {
  skillLevel?: number
}

export type SignInResult =
  | {
      status: 200
      accessKey: string
      settings: SignInUser
      customerId: string
      squads: Squad[]
    }
  | { status: 204 }
  | { status: 410 }

export async function hasCustomerBeenOnboarded(
  token: string,
  inviteCode: string,
  userId?: string,
): Promise<SignInResult> {
  // 204 - no user, aka onboard
  // 200 user created show dash
  // 410 invalid invite show errors

  let url = `${import.meta.env.VITE_SIGN_IN}/${userId}/signIn`

  if (inviteCode && inviteCode.trim() !== '') {
    url = `${url}?inviteCode=${inviteCode}`
  }

  const res = await fetch(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  if (res.status === 200) {
    const data = await res.json()
    if (data.id) {
      return {
        status: 200,
        accessKey: data.apiKey ?? '',
        settings: data,
        customerId: data.workspaceSettings.lastAccessedCustomer.id,
        squads: toSquads(data?.squadrons),
      }
    }

    return { status: 410 }
  }

  if (res.status === 204) {
    return { status: 204 }
  }

  return { status: 410 }
}
